import './Item.scss';

import clsx from 'clsx';
import draftToHtml from 'draftjs-to-html';
import Moment from 'moment';
import React from 'react';
import { useSelector } from 'react-redux';

import { editorLink } from '@/src/globalComponents';

import Form from '../../Form/Form';
import Delete from '../Actions/Delete/Delete';
import Edit from '../Actions/Edit/Edit';
import Reply from '../Actions/Reply/Reply';

const Item = ({
  comment,
  selected,
  handleSelected,
  onReplying,
  isReplyingTo,
  onFetchUsers,
  projectId,
}) => {
  const loggedUser = useSelector((store) => store.loggedUser);
  const document = useSelector((store) => store.comments.document);
  const userComment = comment.users || comment.user;
  const userAvatarUrl = `/api/file/profile_pictures/${userComment.avatar}`;

  const isJsonString = (str) => {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }

    return true;
  };

  const onSelected = (data) => {
    if (handleSelected) {
      handleSelected(data);
    }
  };

  const linkClick = () => {
    if (comment.emailId) {
      localStorage.setItem('emailId', comment.emailId);
    }
  };

  const duration = Moment.duration(Moment().diff(Moment(comment.dateAdded)));

  const date =
    duration.asDays() > 1
      ? Moment(comment.dateAdded).format('MMMM DD, YYYY hh:mm:ss')
      : Moment(comment.dateAdded).fromNow();

  const messageContent =
    isJsonString(comment.comment) &&
    (comment.comment.includes('{"blocks"') || comment.comment.includes('{"entityMap'))
      ? draftToHtml(JSON.parse(comment.comment))
      : typeof comment.comment === 'string'
      ? comment.comment
      : comment.comment.toString();

  if (comment.id === selected.id && selected.type === 'edit') {
    return <Edit comment={comment} selected={selected} handleSelected={onSelected} />;
  }

  const linkUrl = `${process.env.PROTOCOL}${process.env.CLOUD_CFO_URL}viewEmail`;

  // Comment Action Classes ( Reply, Edit, Delete )
  const commentActionClasses = clsx('tw-text-cfo-blue-600 hover:tw-font-brandonTextMedium');

  return (
    <div className={clsx('container--commentItem', 'tw-flex', 'tw-py-[5px] tw-my-[5px]')}>
      <div
        className={clsx(
          'thumbnail-profile',
          'tw-min-w-[25px] tw-max-w-[25px] tw-min-h-[25px] tw-max-h-[25px]',
          'tw-rounded-[50%]',
          'tw-mr-[5px]'
        )}
      >
        <img src={userAvatarUrl} alt="Profile" className="img-responsive" />
      </div>

      {!comment.isDeleted ? (
        <div className={clsx('container--commentDetails', 'tw-w-full')}>
          {/* User Comment: Name & Time */}
          <div
            className={clsx('tw-flex tw-items-center tw-justify-between tw-flex-wrap', 'tw-m-0')}
          >
            <span className={clsx('tw-text-cfo-blue-600 tw-font-brandonTextMedium')}>
              {userComment.firstName + ' ' + userComment.lastName}
            </span>
            <span className={clsx('comment-date', 'tw-text-cfo-grey-600')}>{date}</span>
          </div>

          {comment.emailId && (
            <div className={clsx('email-note', 'tw-py-[15px]', 'tw-text-cfo-black tw-italic')}>
              Note: This comment/message was sent via Email. If the content is not displayed
              correctly, click
              <a
                className={clsx(
                  'tw-text-cfo-black !tw-underline',
                  'hover:!tw-text-cfo-black hover:!tw-underline active:!tw-text-cfo-black'
                )}
                href={linkUrl}
                onClick={linkClick}
                target="_blank"
                rel="noreferrer"
              >
                here
              </a>
            </div>
          )}

          <React.Fragment>
            <div className={clsx('tw-flex tw-items-end')}>
              <div
                className={clsx('message', 'tw-break-words')}
                dangerouslySetInnerHTML={{ __html: editorLink(messageContent) }}
              />
              {comment.isEdit > 0 && (
                <span
                  className={clsx(
                    'editedTag',
                    'tw-text-cfo-grey-600 tw-font-brandonTextMedium tw-italic',
                    'tw-ml-[5px]'
                  )}
                >
                  (Edited)
                </span>
              )}
            </div>
          </React.Fragment>

          {document.isActive && !document.isDeleted && (
            <div className={clsx('container--actions', 'tw-flex tw-items-center', 'tw-my-[10px]')}>
              <Reply
                comment={comment}
                onReplying={onReplying}
                isReplyingTo={isReplyingTo}
                handleSelected={onSelected}
                className={commentActionClasses}
              />
              {userComment.id === loggedUser.data.id && (
                <>
                  <Edit
                    comment={comment}
                    onFetchUsers={onFetchUsers}
                    selected={selected}
                    handleSelected={onSelected}
                    onReplying={onReplying}
                    className={commentActionClasses}
                  />
                  <Delete comment={comment} className={commentActionClasses} />
                </>
              )}
            </div>
          )}
          {comment.id === selected.id && selected.type === 'reply' && isReplyingTo && (
            <Form
              projectId={projectId}
              replyTo={isReplyingTo}
              onReplying={onReplying}
              onFetchUsers={onFetchUsers}
              handleSelected={onSelected}
            />
          )}
        </div>
      ) : (
        <div className={clsx('tw-m-0', 'tw-w-full')}>
          <div
            className={clsx('tw-flex tw-items-center tw-justify-between tw-flex-wrap', 'tw-m-0')}
          >
            <span className={clsx('tw-text-cfo-blue-600 tw-font-brandonTextMedium')}>
              {userComment.firstName + ' ' + userComment.lastName}
            </span>
            <span className={clsx('comment-date', 'tw-text-cfo-grey-600')}>{date}</span>
          </div>

          <p
            className={clsx(
              'deleteNote',
              'tw-my-[5px]',
              'tw-text-cfo-grey-600 tw-font-brandonTextMedium tw-italic'
            )}
          >
            Deleted comment
          </p>
        </div>
      )}
    </div>
  );
};
export default Item;
